import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/agentSubscriptionRequests',
        name: 'agentSubscriptionRequests',
        meta: { sideMenuLabel: "Richieste incaricato" },
        component: () => import("./views/agentSubscriptionRequests.vue")
    },
];

export default routes;